export default function validQuantity(input) {
  return input.trim() !== '';
}
